import { Component, OnInit } from '@angular/core';
import {Observable, Subscription} from "rxjs";
import { NewSavingsAccountService, SavingsAccount, SavingsAccountState } from '@brightside-web/desktop/feature/savings-account';
import {
  TransactionPagination
} from "@brightside-web/desktop/feature/financial-accounts-core";


@Component({
    selector: 'brightside-web-savings-account-transaction-history',
    templateUrl: './savings-account-transaction-history.component.html',
    styleUrls: ['./savings-account-transaction-history.component.scss'],
    standalone: false
})
export class SavingsAccountTransactionHistoryComponent implements OnInit {


  currentAccountInfo: Observable<SavingsAccountState>  = this.savingsSvc.currentAccountInfo;
  transactionsHistory: Observable<TransactionPagination | undefined> = this.savingsSvc.transactionHistory;
  hasMoreTransactions: Observable<boolean> = this.savingsSvc.hasMoreTransactions;

  constructor(private savingsSvc: NewSavingsAccountService) {}

  ngOnInit(): void {
    this.savingsSvc.getSavingsAccounts();
    this.savingsSvc.getNextSavingsTransactionsPage();
  }

  loadMore() {
    this.savingsSvc.getNextSavingsTransactionsPage();
  }

}
